import Bowser from "bowser";

export namespace BrowserService {
  export const browser = Bowser.getParser(window.navigator.userAgent);

  let browsers: Record<string, boolean> | null = null;
  let platforms: Record<string, boolean> | null = null;
  let oss: Record<string, boolean> | null = null;

  export const detectBrowser = () => {
    if (browsers) return browsers;

    const result: Record<string, boolean> = {};

    Object.keys(Bowser.BROWSER_MAP).forEach((x) => {
      const s = browser.is(Bowser.BROWSER_MAP[x]);

      result[x] = s;
    });

    browsers = result;

    return result;
  };

  export const detectPlatform = () => {
    if (platforms) return platforms;

    const result: Record<string, boolean> = {};

    Object.keys(Bowser.PLATFORMS_MAP).forEach((x) => {
      const s = browser.is(Bowser.PLATFORMS_MAP[x]);

      result[x] = s;
    });

    platforms = result;

    return result;
  };

  export const detectOS = () => {
    if (oss) return oss;

    const result: Record<string, boolean> = {};

    Object.keys(Bowser.OS_MAP).forEach((x) => {
      const s = browser.is(Bowser.OS_MAP[x]);

      result[x] = s;
    });

    oss = result;

    return result;
  };

  export const isSamsungBrowser =
    detectOS()["Android"] && detectBrowser()["samsung_internet"];
  export const isIOS = detectOS()["iOS"];
  export const isiPad = /iPad/.test(navigator.userAgent);
  export const isMSIE = detectBrowser()["ie"];
  export const isMobile = detectPlatform()["mobile"];
  export const isDesktop = detectPlatform()["desktop"];
  export const isTablet = detectPlatform()["tablet"];
  export const isAndroid = detectOS()["Android"];
  export const isSafari = detectBrowser()["safari"];
  export const isChrome =
    detectBrowser()["chrome"] || detectBrowser()["chromium"];
  //@ts-ignore
  export const isInStandalone: boolean =
    "standalone" in window.navigator && window.navigator.standalone;
}
